var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomationFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 0.625L11.125 2.125C11.4984 2.50059 12.0054 2.71277 12.535 2.715H14.625C15.1554 2.715 15.6641 2.92571 16.0392 3.30079C16.4143 3.67586 16.625 4.18457 16.625 4.715V6.805C16.6272 7.33458 16.8394 7.84165 17.215 8.215L18.625 9.625L17.125 11.125C16.7494 11.4984 16.5372 12.0054 16.535 12.535V14.625C16.535 15.1554 16.3243 15.6641 15.9492 16.0392C15.5741 16.4143 15.0654 16.625 14.535 16.625H12.445C11.9154 16.6272 11.4083 16.8394 11.035 17.215L9.625 18.625L8.125 17.125C7.75165 16.7494 7.24458 16.5372 6.715 16.535H4.625C4.09457 16.535 3.58586 16.3243 3.21079 15.9492C2.83571 15.5741 2.625 15.0654 2.625 14.535V12.445C2.62277 11.9154 2.41059 11.4083 2.035 11.035L0.625 9.625L2.125 8.125C2.46779 7.73738 2.64701 7.23198 2.625 6.715V4.625C2.625 4.09457 2.83571 3.58586 3.21079 3.21079C3.58586 2.83571 4.09457 2.625 4.625 2.625H6.715C7.24458 2.62277 7.75165 2.41059 8.125 2.035L9.625 0.625Z",
    fill: "#4A81E6",
    stroke: "#4A81E6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 5.625L13.625 9.625L7.625 13.625V5.625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationFilled);
export default __webpack_public_path__ + "static/media/automation_filled.e2efe979b5933177d78ceb6d862fe13a.svg";
export { ForwardRef as ReactComponent };